module.exports = __webpack_public_path__ + "img/settings.e30c8820.svg";